export const WORKFLOW_STATUS = {
  draft: "draft",
  live: "live",
  stopped: "stopped",
}
